import {
  deleteFavoriteByListingId
} from "./chunk-OWEMZM5M.js";
import {
  hasAuthorization
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/deleteFavoriteByListingId/deleteFavoriteByListingId.ts
async function deleteFavoriteByListingId2(listingId, apiConfig) {
  if (!hasAuthorization(apiConfig)) {
    console.warn(
      "JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`"
    );
  }
  try {
    const response = await deleteFavoriteByListingId(listingId, apiConfig);
    return {
      status: "success",
      data: response
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  deleteFavoriteByListingId2 as deleteFavoriteByListingId
};
